export const dateFromDateBack = (fechaBack) => {
    if (!fechaBack) return null;
    
    const { year, monthValue, dayOfMonth } = fechaBack;
    return new Date(year, monthValue - 1, dayOfMonth);
};

export const dateStringF1 = (fecha) => {
    // fecha debe ser Date
    if (!(fecha instanceof Date) || isNaN(fecha)) return '';

    const d = fecha.getDate();
    const m = fecha.getMonth() + 1; 
    const y = fecha.getFullYear();

    return `${d}/${m}/${y}`;
};

/*export const formatToJava = (fecha) => {
    // fecha debe ser Date
    if (!fecha) return "";

    const d = new Date(fecha);
    if(isNaN(d.getTime())) {
        return null;
    }

    return d.toISOString().split('T')[0];
}*/

export const formatToJava = (fecha) => {
    if (!fecha) return "";

    const d = new Date(fecha);
    if (isNaN(d.getTime())) {
        return null;
    }

    // Extraemos año, mes y día de la zona horaria local
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}


export const fechaHoraToJava = (fecha, hora) => {
    if (!fecha || !hora) return "";

    const d = new Date(fecha);
    const t = new Date(hora);

    if (isNaN(d.getTime()) || isNaN(t.getTime())) return "";

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    const hours = String(t.getHours()).padStart(2, '0');
    const minutes = String(t.getMinutes()).padStart(2, '0');
    const seconds = String(t.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    
}

export const dateTimeFromBack = (fechaBack) => {
    if (!fechaBack) return null;
    
    const { 
        year, 
        monthValue, 
        dayOfMonth, 
        hour, 
        minute, 
        second 
    } = fechaBack;

    return new Date(year, monthValue - 1, dayOfMonth, hour || 0, minute || 0, second || 0);
};

export const dateTimeStringF1 = (fecha) => {
    if (!(fecha instanceof Date) || isNaN(fecha)) return '';

    // buscar las fechas
    const d = String(fecha.getDate()).padStart(2, '0');
    const m = String(fecha.getMonth() + 1).padStart(2, '0');
    const y = fecha.getFullYear();

    // buscar las Horas
    const hr = String(fecha.getHours()).padStart(2, '0');
    const min = String(fecha.getMinutes()).padStart(2, '0');
    const sec = String(fecha.getSeconds()).padStart(2, '0');

    // Retornar formato: DD/MM/YYYY HH:mm:ss
    return `${d}/${m}/${y} ${hr}:${min}:${sec}`;
};

